module.exports = __webpack_public_path__ + "static/media/thunderstorm.00169510.svg";